import { BriefcaseBusiness } from "lucide-react";
import { Button } from "flowbite-react";
import JobTable from "./JobTable";
import { ModalFrom } from "./ModalFrom";
import { JobItemsModal } from "./JobItemsModal";
import { ExpensesModal } from "./ExpensesModal";
import { useEffect, useState } from "react";
import axiosInstance from "../config/config";

export default function JobPage() {
  const [openModal, setOpenModal] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [e_id, setEid] = useState(0);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showItemsModal, setShowItemsModal] = useState(false);
  const [showExpensesModal, setShowExpensesModal] = useState(false);

  const fetchjobs = async () => {
    try {
      const response = await axiosInstance.post("", {
        SysID: `select * from dbo.job order by id desc;`,
      });
      setJobs(response.data || []);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    }
  };

  useEffect(() => {
    fetchjobs();
  }, []);

  const opModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
    setEid(0);
  };

  const handleViewItems = (job) => {
    setSelectedJob(job);
    setShowItemsModal(true);
  };

  const handleViewExpenses = (job) => {
    setSelectedJob(job);
    setShowExpensesModal(true);
  };

  return (
    <div className="h-full bg-slate-700 p-4 sm:p-12 overflow-auto">
      <div className="flex align-center items-center gap-2">
        <BriefcaseBusiness className="text-white" size={35} />
        <h1 className="text-4xl font-bold text-white">Jobs</h1>
      </div>
      <div className="flex mt-4">
        <Button
          onClick={() => {
            setEid(0);
            opModal();
          }}
          className="ml-auto"
        >
          + Add Job
        </Button>
      </div>
      <div className="mt-8">
        <JobTable
          jobs={jobs}
          setEid={setEid}
          opModal={opModal}
          onViewItems={handleViewItems}
          onViewExpenses={handleViewExpenses}
        />
      </div>
      {openModal && (
        <ModalFrom closeModal={closeModal} e_id={e_id} fetchjobs={fetchjobs} />
      )}
      {showItemsModal && selectedJob && (
        <JobItemsModal
          closeModal={() => setShowItemsModal(false)}
          job={selectedJob}
        />
      )}
      {showExpensesModal && selectedJob && (
        <ExpensesModal
          closeModal={() => setShowExpensesModal(false)}
          job={selectedJob}
        />
      )}
    </div>
  );
}
